import { createTheme, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useEffect } from "react";
import { Layout, setSidebarVisibility, Sidebar } from "react-admin";
import { useDispatch } from "react-redux";
import { IMenuLink } from "../../types";
import { TPMaterialTheme } from "../tp-materialui";
import CustomAppBar from "./AppBar";
import { FixedOrgDisplay } from "./FixedOrgDisplay";
import Menu from "./Menu";

export interface ICustomLayoutProps {
  links: Array<IMenuLink>;
  hideResources: boolean;
  hideDashboard: boolean;
  orgPicker?: JSX.Element;
  [key: string]: any;
}

const useSidebarStyles = makeStyles((theme) => ({
  drawerPaper: { zIndex: 2 }, // this should be applied through the theme, but haven't worked out how
}));

const CustomLayout = (props: ICustomLayoutProps) => {
  const {
    dashboard,
    links,
    hideResources,
    hideDashboard,
    theme,
    orgPicker = <FixedOrgDisplay />,
    ...other
  } = props;

  const getMenu = () => {
    return Menu({ links, hideResources, hideDashboard, ...other });
  };

  const classesForSidebar = useSidebarStyles();
  const getSideBar = (props) => (
    <Sidebar {...{ ...props, classes: classesForSidebar }} size={200} />
  );

  const getAppBar = () => <CustomAppBar {...other} orgPicker={orgPicker} />;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSidebarVisibility(false));
  });

  return (
    <Layout
      {...other}
      appBar={getAppBar}
      sidebar={getSideBar}
      theme={createTheme(TPMaterialTheme, theme)}
      menu={getMenu}
      title="" /* Suppress tooltips */
    />
  );
};

export default CustomLayout;
